"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterToColor = void 0;
const filterToHex_1 = require("./filterToHex/filterToHex");
const hexToColor_1 = require("./hexToColor/hexToColor");
class FilterToColor {
    static async filterToHex(filterString) {
        const result = await filterToHex_1.FilterToHex.convert(filterString);
        if (result.color)
            result.color = result.color.toUpperCase();
        return result;
    }
    static async filterToRgb(filterString, options) {
        return filterToHex_1.FilterToHex.convert(filterString, hexToColor_1.HexToColor.convertToRgb, options);
    }
    static async filterToHsl(filterString, options) {
        return filterToHex_1.FilterToHex.convert(filterString, hexToColor_1.HexToColor.convertToHsl, options);
    }
}
exports.FilterToColor = FilterToColor;
